export const editorTheme = {
  variable: {
    border: '#7AD3C1',
    background: '#BEF3E9',
    text: '#008371',
  },
  tag: {
    border: '#F27FA6',
    background: '#F9C4D6',
    text: '#822343',
  },
  variant: {
    border: '#BBC2CB',
    background: '#F0F2F4',
    text: '#4D5B6E',
  },
};
